module.exports = __webpack_public_path__ + "static/img/banner_05.5326adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_05.jpg
// module id = 444x
// module chunks = 9